export function notificationsCount(state) {
  return state.notificationsCount;
}

export function toasts(state) {
  return state.toasts;
}

export function activeRibbon(state) {
  return state.activeRibbon;
}
